import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import {
  fulfillmentSettingsService,
  type UpdateFulfillmentAccountingSettingsPayload,
  type UpdateFulfillmentGeneralSettingsPayload,
  type UpdateFulfillmentShippingServiceSettingsPayload,
} from '@/services/fulfillment-settings.service';

export const FULFILLMENT_ACCOUNTING_SETTINGS_QUERY_KEY = [
  'fulfillment',
  'settings',
  'accounting',
] as const;

export function useFulfillmentAccountingSettings() {
  return useQuery({
    queryKey: FULFILLMENT_ACCOUNTING_SETTINGS_QUERY_KEY,
    queryFn: () => fulfillmentSettingsService.getAccountingSettings(),
  });
}

export function useUpdateFulfillmentAccountingSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateFulfillmentAccountingSettingsPayload) =>
      fulfillmentSettingsService.updateAccountingSettings(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: FULFILLMENT_ACCOUNTING_SETTINGS_QUERY_KEY });
    },
  });
}

export const FULFILLMENT_SHIPPING_SERVICE_SETTINGS_QUERY_KEY = [
  'fulfillment',
  'settings',
  'shipping-service',
] as const;

export function useFulfillmentShippingServiceSettings() {
  return useQuery({
    queryKey: FULFILLMENT_SHIPPING_SERVICE_SETTINGS_QUERY_KEY,
    queryFn: () => fulfillmentSettingsService.getShippingServiceSettings(),
  });
}

export function useUpdateFulfillmentShippingServiceSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateFulfillmentShippingServiceSettingsPayload) =>
      fulfillmentSettingsService.updateShippingServiceSettings(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: FULFILLMENT_SHIPPING_SERVICE_SETTINGS_QUERY_KEY });
    },
  });
}

export const FULFILLMENT_GENERAL_SETTINGS_QUERY_KEY = [
  'fulfillment',
  'settings',
  'general',
] as const;

export function useFulfillmentGeneralSettings() {
  return useQuery({
    queryKey: FULFILLMENT_GENERAL_SETTINGS_QUERY_KEY,
    queryFn: () => fulfillmentSettingsService.getGeneralSettings(),
  });
}

export function useUpdateFulfillmentGeneralSettings() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (body: UpdateFulfillmentGeneralSettingsPayload) =>
      fulfillmentSettingsService.updateGeneralSettings(body),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: FULFILLMENT_GENERAL_SETTINGS_QUERY_KEY });
    },
  });
}
